module.exports = __webpack_public_path__ + "static/media/2.0ab4f4e1.jpg";